import sha256 from 'crypto-js/sha256'

/**
 * Generates a Gravatar image URL from an email address.
 * Follows Gravatar's specifications: https://docs.gravatar.com/api/avatars/hash/
 *
 * @param email - The email address to hash. If email is falsy, returns the url to fetch the default image.
 * @returns The Gravatar image URL with the SHA-256 hash of the email, or the url to fetch the default image if the email is empty.
 */
const getGravatarImageUrl = ({ email, size }: { email?: string; size: number }): string => {
  if (!email) {
    return 'https://gravatar.com/avatar?d=mp'
  }

  // 1. Trim leading and trailing whitespace
  // 2. Convert to lowercase
  // 3. Hash the final string with SHA-256
  const emailHash = sha256(email.trim().toLowerCase()).toString()

  // Construct the Gravatar URL using the email hash and a default fallback image
  return `https://gravatar.com/avatar/${emailHash}?d=mp&s=${size}`
}

export default function GravatarImage({
  email,
  imgHeight,
  imgWidth,
  size = 200,
}: {
  email?: string
  imgHeight: number
  imgWidth: number
  size?: number // determines the width and height of the square image in pixels that Gravatar will return
}) {
  return (
    <img
      style={{ borderRadius: '50%' }}
      src={getGravatarImageUrl({ email, size })}
      alt="Profile Image"
      width={imgWidth}
      height={imgHeight}
    />
  )
}
